import styles from '@/modules/perseo-billing/containers/payment-methods/components/cencopay/styles.module.scss';
import { useGetCartTotals } from '@/modules/perseo-billing/hooks';
import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

export default function PricesComponent() {
  const { otherMethods, cencoPay, cencosudCard } = useGetCartTotals();

  return (
    <div className="co-mb-[28px] co-flex co-flex-col co-items-center co-gap-y-[12px]">
      <Typography size="h3" weight="semibold">
        {cencoPay?.price ? 'Totales con CencoPay:' : 'Total a pagar'}
      </Typography>
      {cencoPay?.price && cencosudCard?.price ? (
        <div className="co-flex co-flex-col co-min-w-[292px] co-gap-[18px]">
          <div
            className={
              'co-flex co-justify-between co-items-center ' +
              styles.iconContainer
            }
          >
            <Typography>Tarjeta Cencosud:</Typography>
            <div className="co-flex co-items-center co-gap-[8px]">
              <Icon icon="CencoScotiabankIcon" />
              <Icon width={32} height={32} icon="CencopayCard" />
              <Typography weight="medium" className="!co-text-[20px]">
                {cencosudCard?.price}
              </Typography>
            </div>
          </div>
          <div className="co-flex co-justify-between co-items-center">
            <Typography>Otras tarjetas:</Typography>
            <div className="co-flex co-items-center co-gap-[8px]">
              <Icon width={32} height={32} icon="CencopayCard" />
              <Typography weight="medium" className="!co-text-[20px]">
                {otherMethods?.price}
              </Typography>
            </div>
          </div>
        </div>
      ) : (
        <div className="co-flex co-items-center co-gap-[8px] co-justify-between">
          <Icon width={32} height={32} icon="CencopayCard" />
          <Typography weight="medium" className="!co-text-[20px]">
            {otherMethods?.price}
          </Typography>
        </div>
      )}
    </div>
  );
}
